export default __webpack_public_path__ + "static/best-in-field-2-a1e664310d1cde236bc6bb4288decdf1.webp";